import { render, staticRenderFns } from "./edit-task.vue?vue&type=template&id=5b7faed1&scoped=true&"
import script from "./edit-task.vue?vue&type=script&lang=js&"
export * from "./edit-task.vue?vue&type=script&lang=js&"
import style0 from "./edit-task.vue?vue&type=style&index=0&id=5b7faed1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7faed1",
  null
  
)

export default component.exports